module.exports = __webpack_public_path__ + "assets/911a11d97f494470f7d7738ba7f563a6.png";